module.exports = __webpack_public_path__ + "static/media/logoSidebar.011c696f.svg";